module.exports = __webpack_public_path__ + "static/img/IMG_9738_bw_new.cd29d16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/IMG_9738_bw_new.jpg
// module id = fEET
// module chunks = 1